import { LockedArt } from '@/components/illustrations';
import { Card, CardContent } from '@/components/cargofl-ui';
import { SignOutButton } from '@/routes/account-disabled';

/**
 * Signed in to Google, but no employee record exists.
 *
 * A separate screen from "not signed in" on purpose: their credentials are fine, so
 * sending them to the login page would loop them straight back here. What they need
 * is HR, and the page says so rather than making them work it out.
 */
export function NotOnboardedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4">
      <Card className="w-full max-w-[480px]">
        <CardContent className="space-y-5 py-10 text-center sm:py-10">
          <LockedArt className="mx-auto h-28 w-auto" />
          <h1 className="text-lg font-semibold">You are not set up yet</h1>
          <p className="text-sm text-muted-foreground">
            Your Google sign-in worked, but there is no employee record for this address in
            the asset tracker yet. Ask HR to add you — they need your employee ID, which is
            what every asset issued to you is recorded against.
          </p>
          <p className="text-xs text-muted-foreground">
            Once they have, sign in again and your assets will be here.
          </p>
          <SignOutButton />
        </CardContent>
      </Card>
    </div>
  );
}
